import Validator from "./Validator";

export default class JsonEntitiesEntityDataButtonLabelValidator extends Validator {
  constructor() {
    super();
    this.validationRules = {
      type: 'string',
      empty: false,
      mandatory: false
    };
  }
}
